(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pg-faq-controls')) {
    customElements.define('pg-faq-controls', class extends HTMLElement {
      async connectedCallback() {
        await customElements.whenDefined('collapsible-content');
        if (!this.isConnected || this.controller) return;

        this.wrapper = this.closest('.faq__wrapper');
        this.button = this.querySelector('button');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const panels = () => Array.from(this.wrapper.querySelectorAll('.faq__item collapsible-content'));
        const sync = () => {
          const allOpen = panels().length > 0 && panels().every(panel => panel.open);
          this.button.textContent = allOpen ? 'Close all' : 'Open all';
        };

        this.button.addEventListener('click', () => {
          const items = panels();
          const open = !items.every(panel => panel.open);
          items.forEach(panel => {
            if (panel.open !== open) panel.open = open;
          });
        }, options);
        this.wrapper.addEventListener('openable-element:open', sync, options);
        this.wrapper.addEventListener('openable-element:close', sync, options);
        sync();
        this.button.hidden = false;
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pg__testimonial-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pg-testimonial-carousel')) {
    class PGTestimonialCarousel extends HTMLElement {
      connectedCallback() {
        if (this._initialized) return;

        this._initialized = true;
        this._track = this.querySelector('[data-pg-testimonial-carousel-track]');
        this._controls = this.querySelector('[data-pg-testimonial-carousel-controls]');
        this._dots = this.querySelector('[data-pg-testimonial-carousel-dots]');
        this._slides = this._track ? Array.from(this._track.querySelectorAll('.pg-testimonial-carousel__slide')) : [];
        this._cards = this._track ? Array.from(this._track.querySelectorAll('.pg-testimonial-carousel__card')) : [];
        this._images = this._track ? Array.from(this._track.querySelectorAll('img')) : [];

        this._handleClick = this._handleClick.bind(this);
        this._handleSelect = this._handleSelect.bind(this);
        this._handleModalOpen = this._handleModalOpen.bind(this);
        this._handleModalClose = this._handleModalClose.bind(this);
        this._handleBlockSelect = this._handleBlockSelect.bind(this);
        this._queueHeightSync = this._queueHeightSync.bind(this);

        this.addEventListener('click', this._handleClick);
        this.addEventListener('openable-element:open', this._handleModalOpen);
        this.addEventListener('openable-element:close', this._handleModalClose);
        this.addEventListener('shopify:block:select', this._handleBlockSelect);
        window.addEventListener('resize', this._queueHeightSync);

        this._images.forEach((image) => image.addEventListener('load', this._queueHeightSync));
        this._setupCarousel();
        this._queueHeightSync();

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this._queueHeightSync();
          });
        }
      }

      disconnectedCallback() {
        if (!this._initialized) return;

        this.removeEventListener('click', this._handleClick);
        this.removeEventListener('openable-element:open', this._handleModalOpen);
        this.removeEventListener('openable-element:close', this._handleModalClose);
        this.removeEventListener('shopify:block:select', this._handleBlockSelect);
        window.removeEventListener('resize', this._queueHeightSync);
        this._images.forEach((image) => image.removeEventListener('load', this._queueHeightSync));

        if (this._heightFrame) cancelAnimationFrame(this._heightFrame);
        if (this._resizeFrame) cancelAnimationFrame(this._resizeFrame);

        this.querySelectorAll('[data-pg-testimonial-carousel-modal]').forEach((modal) => {
          modal.open = false;
          this._resetVideos(modal);
        });

        if (this._flkty) {
          this._flkty.off('select', this._handleSelect);
          this._flkty.destroy();
        }

        this._flkty = null;
        this._initialized = false;
      }

      _setupCarousel() {
        if (!this._track || this._slides.length < 2 || typeof window.Flickity === 'undefined') {
          if (this._controls) this._controls.hidden = true;
          this._updateSlides(0);
          return;
        }

        this._flkty = typeof window.Flickity.data === 'function' ? window.Flickity.data(this._track) : null;

        if (!this._flkty) {
          this._flkty = new window.Flickity(this._track, {
            cellAlign: 'center',
            pageDots: false,
            prevNextButtons: false,
            wrapAround: true
          });
        }

        this.classList.add('is-carousel-enabled');
        this._renderDots();
        this._flkty.on('select', this._handleSelect);
        this._handleSelect();

        if (this._controls) this._controls.hidden = false;
      }

      _renderDots() {
        if (!this._dots) return;

        this._dots.innerHTML = '';
        this._slides.forEach((slide, index) => {
          const dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'pg-testimonial-carousel__dot';
          dot.dataset.pgTestimonialCarouselDot = index;
          dot.setAttribute('aria-label', `Go to testimonial ${index + 1}`);
          this._dots.appendChild(dot);
        });
      }

      _handleClick(event) {
        const modalBackdrop = event.target.closest('.pg-testimonial-carousel__modal-inner');
        if (modalBackdrop && event.target === modalBackdrop) {
          const modal = modalBackdrop.closest('[data-pg-testimonial-carousel-modal]');
          const closeButton = modal ? modal.querySelector('.modal__close-button') : null;
          if (closeButton) closeButton.click();
          return;
        }

        if (!this._flkty) return;

        const previous = event.target.closest('[data-pg-testimonial-carousel-prev]');
        const next = event.target.closest('[data-pg-testimonial-carousel-next]');
        const dot = event.target.closest('[data-pg-testimonial-carousel-dot]');

        if (previous && this.contains(previous)) {
          this._flkty.previous();
        } else if (next && this.contains(next)) {
          this._flkty.next();
        } else if (dot && this.contains(dot)) {
          this._flkty.select(Number(dot.dataset.pgTestimonialCarouselDot));
        }
      }

      _handleSelect() {
        const selectedIndex = this._flkty ? this._flkty.selectedIndex : 0;
        this._updateSlides(selectedIndex);

        if (this._dots) {
          this._dots.querySelectorAll('.pg-testimonial-carousel__dot').forEach((dot, index) => {
            const isActive = index === selectedIndex;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        }
      }

      _updateSlides(selectedIndex) {
        const slideCount = this._slides.length;
        const previousIndex = slideCount > 1 ? (selectedIndex - 1 + slideCount) % slideCount : -1;
        const nextIndex = slideCount > 1 ? (selectedIndex + 1) % slideCount : -1;

        this._slides.forEach((slide, index) => {
          const isSelected = index === selectedIndex;
          slide.classList.toggle('is-before', index === previousIndex);
          slide.classList.toggle('is-after', index === nextIndex);
          if (isSelected) {
            slide.setAttribute('aria-current', 'true');
          } else {
            slide.removeAttribute('aria-current');
          }

          if ('inert' in slide) {
            slide.inert = !isSelected;
          } else {
            slide.querySelectorAll('a, button').forEach((element) => {
              if (isSelected) {
                element.removeAttribute('tabindex');
              } else {
                element.setAttribute('tabindex', '-1');
              }
            });
          }
        });
      }

      _handleModalOpen(event) {
        const modal = event.target;
        if (!modal.matches || !modal.matches('[data-pg-testimonial-carousel-modal]')) return;

        const video = modal.querySelector('video');
        if (!video) return;

        video.pause();
        try { video.currentTime = 0; } catch (error) {}

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {});
        }
      }

      _handleModalClose(event) {
        const modal = event.target;
        if (!modal.matches || !modal.matches('[data-pg-testimonial-carousel-modal]')) return;
        this._resetVideos(modal);
      }

      _resetVideos(container) {
        container.querySelectorAll('video').forEach((video) => {
          video.pause();
          try { video.currentTime = 0; } catch (error) {}
        });
      }

      _handleBlockSelect(event) {
        if (!this._flkty) return;

        const slide = event.target.closest('.pg-testimonial-carousel__slide');
        if (!slide || !this.contains(slide)) return;

        const index = this._slides.indexOf(slide);
        if (index >= 0) this._flkty.select(index, false, true);
      }

      _queueHeightSync() {
        this.style.removeProperty('--pg-testimonial-carousel-card-height');
        if (this._heightFrame) cancelAnimationFrame(this._heightFrame);

        this._heightFrame = requestAnimationFrame(() => {
          const maxHeight = this._cards.reduce((height, card) => Math.max(height, card.offsetHeight), 0);
          if (maxHeight > 0) {
            this.style.setProperty('--pg-testimonial-carousel-card-height', `${Math.ceil(maxHeight)}px`);
          }

          if (this._resizeFrame) cancelAnimationFrame(this._resizeFrame);
          this._resizeFrame = requestAnimationFrame(() => {
            if (this._flkty) this._flkty.resize();
          });
        });
      }
    }

    customElements.define('pg-testimonial-carousel', PGTestimonialCarousel);
  }

  } catch(e) { console.error(e); }
})();
})();
